'use strict';

module.exports = function flash(color, title, message, icon, timeout) {
	timeout = timeout || 10000;
	icon = icon || 'info-circle';
	switch (color) {
		case 'info':
			color = '#9cb4c5';
			break;
		case 'warning':
			color = '#dfb56c';
			break;
		case 'danger':
			// color = '#953b39';
			color = '#a65858';
			break;
		case 'success':
			color = '#8ac38b';
			break;
		default:
			color = '#9cb4c5';
			break;
	}
	setTimeout(function () {
		window.jQuery.smallBox({
			title: title,
			content: "<i class='fa fa-" + icon + "'></i> <em>" + message + '</em>',
			color: color,
			iconSmall: 'fa fa-' + icon + ' fa-2x fadeInRight animated',
			timeout: timeout,
			sound: false
		});
	}, 100);
};
